
const NotificationForm = () => {
  return (
    <span>NotificationForm</span>
  );
  
};

export default NotificationForm;
